module.exports = __webpack_public_path__ + "frontend/images/pattern/gold.jpg?1028b18008694f06d1c7bfc4d955380c";